"use client"
import React from 'react';
import { useScopedI18n } from '@locales/client';
import { Button } from '@/shared/ui/form/button/button';
import { useBrandTheme } from '@/shared/hooks/useBrandTheme';
import { webpPngFallback } from '@/shared/ui/image/Image';
import { BodyTextRegularC, BodyTextMediumB, BodyTextMediumC } from '@/shared/ui/typography2';
import * as Dialog from '@radix-ui/react-dialog';
import { StyledAlertDialogOverlay } from '@/shared/ui/alert-dialog/styles';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  StyledTermsReminderDialogContent,
  Navigation,
  InfoContainer,
  ListSection,
  LogoWrapper,
  ListBox,
  ListScrollArea,
  ListTitle,
  StepsList,
  LogoImage,
  // закрытие временно отключено: флоу принудительный, закрыть нельзя, пока не подтверждён
  // CloseButton,
  // CloseIconImage,
} from './styles';
import { ButtonWrapper } from '@/features/login-confirmation-modal/styles';

interface StepContent {
  key: string;
  content: React.ReactNode;
}

interface TermsReminderStepProps {
  isOpen: boolean;
  onAccept: () => void;
}

const TERMS_LIST_LENGTH = 15;

const StepList = ({ steps }: { steps: StepContent[] }) => (
  <StepsList>
    {steps.map((step) => (
      <li key={step.key}>
        <BodyTextRegularC color="#AFAFAF" style={{ whiteSpace: 'pre-line' }}>
          {step.content}
        </BodyTextRegularC>
      </li>
    ))}
  </StepsList>
);

export const TermsReminderStep = ({ isOpen, onAccept }: TermsReminderStepProps) => {
  const t = useScopedI18n('login_confirmation_modal.terms');
  const tShared = useScopedI18n('login_confirmation_modal');
  const { assets } = useBrandTheme();
  const isClient = typeof window !== 'undefined';

  const title = t('title');
  const listTitle = t('list_title');
  const acceptButtonText = tShared('accept_button');

  const listItems: StepContent[] = Array.from(
    { length: TERMS_LIST_LENGTH },
    (_, index) => ({
      key: `item-${index}`,
      content: t(`list.${index}`),
    })
  );

  if (!isClient) {
    return null;
  }

  return (
    // закрытие временно отключено: флоу принудительный, закрыть нельзя, пока не подтверждён
    // onOpenChange={onClose}
    <Dialog.Root open={isOpen} onOpenChange={() => {}}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay />
        <StyledTermsReminderDialogContent aria-describedby="" data-item="terms_reminder">
          <VisuallyHidden>
            <Dialog.Title>{title}</Dialog.Title>
          </VisuallyHidden>

          <InfoContainer>
            <Navigation>
              {/* закрытие временно отключено: флоу принудительный, закрыть нельзя, пока не подтверждён */}
              {/* <CloseButton onClick={onClose}>
                <CloseIconImage
                  src="/images/icons/close-dialog.svg"
                  alt={closeButtonText}
                />
              </CloseButton> */}
            </Navigation>

            <LogoWrapper>
              <LogoImage
                src={assets.logo.footer ?? assets.logo.default}
                alt="logo"
                fallback={webpPngFallback(assets.logo.footer ?? assets.logo.default, 'logo')}
              />
            </LogoWrapper>

            <ListSection>
              <BodyTextMediumB style={{ textAlign: 'center' }}>{title}</BodyTextMediumB>

              <ListBox>
                <ListScrollArea>
                  <ListTitle>
                    <BodyTextMediumC color="#AFAFAF">{listTitle}</BodyTextMediumC>
                  </ListTitle>
                  <StepList steps={listItems} />
                </ListScrollArea>
              </ListBox>
            </ListSection>
          </InfoContainer>

          <ButtonWrapper>
            <Button
              type="button"
              onClick={onAccept}
              variant="orangeGradient"
              fill
              data-analytics-id="terms_reminder"
            >
              <BodyTextMediumB>{acceptButtonText}</BodyTextMediumB>
            </Button>
          </ButtonWrapper>
        </StyledTermsReminderDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
